export default function checklistHashRedirect() {
  let el
  const urlParam = name => {
    const results = new RegExp("[\\?&]" + name + "=([^&#]*)").exec(window.location.href)
    return results ? results[1] : 0
  }

  const partnerContext = () => (window.location.pathname.includes("triggers") ? "partner_trigger" : "partner_action")

  setTimeout(() => {
    switch (window.location.hash) {
      case "#api_url":
        document.querySelector("#partners_service_api_url_prefix")?.focus()
        break

      case "#auth_url":
        document.querySelector("#partners_service_oauth_authorization_url")?.focus()
        break

      case "#token_url":
        document.querySelector("#partners_service_oauth_token_url")?.focus()
        break

      case "#general_description":
        document.querySelector("#partners_service_description")?.focus()
        break

      case "#brand_color":
        document.querySelector("#partners_service_brand_color")?.focus()
        break

      case "#home_url":
        document.querySelector("#partners_service_home_url")?.focus()
        break

      case "#support_email":
        document.querySelector("#partners_service_support_email")?.focus()
        break

      case "#client_id":
        document.querySelector("#partners_service_oauth_client_id")?.focus()
        break

      case "#client_secret":
        document.querySelector("#partners_service_oauth_client_secret")?.focus()
        break

      case "#demo_login":
        document.querySelector("#partners_service_demo_account_login")?.focus()
        break

      case "#demo_password":
        document.querySelector("#partners_service_demo_account_password")?.focus()
        break

      case "#date_time":
        document.querySelector("input[value='Add ingredient']").click()
        break

      case "#description":
        document.querySelector(`textarea[name="${partnerContext()}[description]"]`)?.focus()
        break

      case "#verbiage":
        document.querySelector(`textarea[name="${partnerContext()}[verbiage]"]`)?.focus()
        break

      case "#banned_name":
      case "#banned_note":
      case "#banned_slug":
      case "#banned_example":
        el = document.querySelector(`li[data-ingredient-id='${urlParam("ingredient_id")}'] > .links > button`)
        el?.focus()
        el?.click()
        break

      case "#banned_label":
      case "#banned_helper":
      case "#banned_dropdown":
        if (urlParam("section") === "trigger_fields") {
          el = document.querySelector(`li[data-trigger-field-id='${urlParam("section_id")}'] > .links > button`)
        } else if (urlParam("section") === "action_fields") {
          el = document.querySelector(`li[data-action-field-id='${urlParam("section_id")}'] > .links > button`)
        }
        el?.focus()
        el?.click()
        break
    }
  }, 350)
}
